import React, { useEffect, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Skeleton from "react-loading-skeleton";
import { Link } from "react-router-dom";

const SingleItem = ({ data }) => {
  const [livePrice, setLivePrice] = useState([]);
  const [loading, setLoading] = useState(true);
  const { stocks_id: StocksData } = data;

  useEffect(() => {
    const interval = setInterval(() => {
      fetchData();
    }, 1000);
    return () => clearInterval(interval);
  }, [livePrice]);

  const fetchData = async () => {
    if (StocksData !== null) {
      fetch(
        `https://api.massive.com/v2/snapshot/locale/us/markets/stocks/tickers/${StocksData?.symbol}?apiKey=${process.env.REACT_APP_POLYGON_API_KEY}`,
        {
          method: "GET",
        }
      )
        .then((res) => res.json())
        .then((data) => {
          if (data?.ticker) {
            setLivePrice(data?.ticker);
            setLoading(false);
          }
        })
        .catch((error) => {
          // console.log(error);
        });
    }
  };
  if (loading || StocksData === null) {
    return;
  }
  return (
    <>
      <div className="markets-coin">
        <Link to={`/user/live/trade/stocks/${StocksData?._id}`}>
          <div className="markets-coin-left">
            <div className="markets-coin-image">
              <LazyLoadImage
                effect="blur"
                alt="img"
                src={`https://api.wlffinance.org/${StocksData?.image}`}
                className="hot-coin-img"
              />
            </div>
            <div className="markets-coin-name">
              <h4> {StocksData?.name}</h4>
              <h5>{StocksData?.symbol}</h5>
            </div>
          </div>
          <div className="markets-coin-right">
            <div className="markets-coin-price">
              <p>
                $
                {!isNaN(livePrice?.lastTrade?.p) &&
                  parseFloat(livePrice?.lastTrade?.p) +
                    parseFloat(StocksData?.price)}
              </p>
            </div>
            <div className="markets-coin-percentage">
              <p
                className={`${
                  livePrice?.todaysChangePerc >= 0 ? "up-price" : "dwon-price"
                }`}
              >
                <i class="fa-solid fa-arrow-right"></i>
                {parseFloat(livePrice?.todaysChangePerc).toFixed(2)}%
              </p>
            </div>
          </div>
        </Link>
      </div>
    </>
  );
};

export default SingleItem;
